<template>
  <div>
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header @toggleSidebar="toggleSidebar" />
    <!--====== POST LAYOUT 1 PART START ======-->

    <section v-loading="isLoading" class="bg-white">
      <div class="container">
        <div class="pt-20 pb-20 pl-20 pr-20">
          <div class="row">
            <div class="col-lg-12">
              <div class="post-layout-top-content post-layout-top-content-2">
                <div class="post-title">
                  <div class="post-content">
                    <h3 class="title">
                      {{ event.fullname }}
                    </h3>
                  </div>
                  <div
                    class="
                      post-categories
                      d-flex
                      justify-content-start
                      align-items-center
                    "
                  >
                    <div>{{ formatTimestampToDate(event.createdat) }}</div>
                  </div>
                </div>
                <div class="post-text mt-30">
                  <div v-html="processedRichTextBody"></div>
                </div>

                <div v-if="files.length > 0">
                  <div class="download-text">
                    点击下方下载附件：
                  </div>

                  <template v-for="(file, index) in files">
                    <div :key="index">
                      <a class="download-file" :href="file.fileurl" target="_blank">
                        附件 {{ index + 1 }}：{{ file.name }}</a>
                    </div>
                  </template>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="floating-actions" v-if="allowreg">
          <!--           
          <div class="action-icon wechat-icon bg-white">
            <img src="@/assets/icons/kf.png" alt="客服" style="width: 30px;" />
          </div> 
          -->

          <div class="cursor-pointer" @click="handleRegisterClick"> 
            <img src="@/assets/images/button/reg20.png" alt="课题中心" v-if="event.type == 20" style="width: 130px;" />
            <img src="@/assets/images/button/reg21.png" alt="比赛活动" v-else-if="event.type == 21" style="width: 130px;" />
            <img src="@/assets/images/button/reg22.png" alt="比赛活动" v-else-if="event.type == 22" style="width: 130px;" />
            <div class="action-icon register-icon bg-white" v-else>
              <img src="@/assets/icons/edit.png" alt="报名" style="width: 30px;" />
            </div>
          </div>
        </div>

      </div>
    </section>

    <!--====== POST LAYOUT 1 PART ENDS ======-->

    <footer-one />
    <!--====== GO TO TOP PART START ======-->
    <div class="go-top-area" style="display: none;">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
    
    <!--====== GO TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import Header from "../../Utility/Header/index";
import Posts from "../../Data/TrendingHomeThree";
import FooterOne from "../../Utility/Footer/FooterOne.vue";
import Drawer from "../../Mobile/Drawer.vue";
import { formatTimestampToDate } from '@/utils/dateUtil';
import profileService from '@/utils/profileService';

import { 
  getEvent,
  getEventRichtext,
  getEventFiles,
  getEventSettings
} from "@/api/event";


export default {
  components: { Header, FooterOne, Drawer },
  data: () => ({
    Posts: Posts.data,
    sidebar: false,
    isLoading: true,
    event: {},
    files: [],
    richtextBody: '',
    processedRichTextBody: '',
    allowreg: false,
    midtime: null,
    finaltime: null,
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
    this.fetchEventData();
    this.fetchSetting();
  },
  computed: {
    userProfile() {
      return profileService.getProfile();
    }
  },

  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
    async fetchEventData() {
      const eventId = this.$route.params.id; 
      if (eventId) {
        try {
          // 同时发起三个请求，提高加载效率
          const [eventResponse, richtextResponse, filesResponse] = await Promise.all([
            getEvent(eventId),
            getEventRichtext(eventId),
            getEventFiles(eventId)
          ]);

          // 处理事件基本信息
          this.event = eventResponse.data; 
          console.log(this.event);

          this.prevArticle = eventResponse.rev;
          this.nextArticle = eventResponse.next;

          // 处理附件信息
          if (filesResponse.code === 200) {
            this.files = filesResponse.list || [];
          }

          // 处理富文本内容
          if (richtextResponse.code === 200) {
            this.richtextBody = richtextResponse.data.body || '';
            this.processedRichTextBody = this.richtextBody; 
          }

          // 处理报名按钮图片
          const typeToImageMap = {
            1: 20,
            2: 21,
            3: 22
          };
          this.regImageNumber = typeToImageMap[this.event.type] || 20;

        } catch (error) {
          console.error('获取文章数据失败:', error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    async fetchSetting() {
      const eventId = this.$route.params.id; 
      if (eventId) {
        try {
          const response = await getEventSettings(eventId);
          if (response.code === 200) {
            this.eventSettings = response.data;
            const rules = this.eventSettings.rules[0];
        
            const allowregRule = rules.allowreg;
            const midtimeRule  = rules.midtime;
            const finaltimeRule = rules.finaltime;
        
            if (midtimeRule) {
              this.midtime = midtimeRule;
            }
            
            if (finaltimeRule) {
              this.finaltime = finaltimeRule;
            }

            console.log(this.midtime, this.finaltime);


            if (allowregRule) {
              this.allowreg = allowregRule;
            }

            console.log('allowreg:',this.allowreg);

          }
        } catch (error) {
          console.error('获取事件设置失败:', error);
        }
      }
    },
    handleRegisterClick() {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message({
          message: '请先登录',
          type: 'warning',
        });
        return;
      }

      if (!this.userProfile) {
        this.$message({
          message: '请先登录',
          type: 'warning',
        });
        return;
      }

      const eventid = this.$route.params.id;
      this.$router.push({ 
        name: 'EventForm', 
        params: { eventid },
      });
      window.scrollTo(0, 0);

    },

    formatTimestampToDate,
  },
};
</script>

<style>
.post-layout-top-content.post-layout-top-content-2 {
  padding: unset!important;
  margin: unset!important;
  min-height: 400px;
}
.post-layout-top-content .post-content .title {
  font-size: 18px !important;
}
.post-title { 
  border-bottom: 1px solid #e1e7f2;
  padding-bottom: 20px;
}
.download-text{
  color: rgb(68, 68, 68);
  font-size: 18px;
  padding: 10px 0 20px 0;
}
.download-file{
  font-size: 18px;
  color: rgb(0, 102, 204);
}
/* 新增附件项行间距样式 */
.download-item {
  margin-bottom: 12px; /* 可根据需要调整数值，数值越大行间距越大 */
}

.floating-actions {
  position: fixed;
  right: 5px;
  top: 40%; /* 中间偏上位置 */
  z-index: 100; /* 确保悬浮在其他内容之上 */
}

.action-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  color: white;
  font-size: 24px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
}

.post-layout-top-content.post-layout-top-content-2 {
  padding: unset!important;
  margin: unset!important;
}

</style>
